import type Transition from '@ember/routing/transition';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import SidebarBookingsSummaryRoute from 'uplisting-frontend/pods/-sidebar/bookings/summary/route';

export default abstract class SidebarBookingsSummaryModifyRoute extends SidebarBookingsSummaryRoute {
  abstract summaryRoute: string;

  afterModel(
    model: SidebarBookingsSummaryModifyRouteModel,
    transition: Transition,
  ): void {
    super.afterModel(model, transition);

    const booking = this.modelFor(
      this.summaryRoute,
    ) as ModelRegistry['booking'];

    if (!booking.canBeModified) {
      this.router.transitionTo(this.summaryRoute, booking.id);
    }
  }
}

export type SidebarBookingsSummaryModifyRouteModel =
  RouteModel<SidebarBookingsSummaryModifyRoute>;
